import { memo, useCallback } from "react";

import { useNavigate } from "react-router-dom";

/* =========================================================
   NEW ARRIVAL IMAGES
========================================================= */

const NEW_ARRIVAL_IMAGES = [
	{
		id: "RS212",
		brand: "Risky Collection",
    url: "https://admin.monsinidress.com/uploads/Risky/2027/FA27/main/RS212/RS212.jpg",
		
		filename: "Risky RS212",
	},

	{
		id: "RS203",
		brand: "Risky Collection",
		url: "https://admin.monsinidress.com/uploads/Risky/2027/FA27/main/RS203/RS203.jpg",
		filename: "Risky RS203",
	},

	{
		id: "RS208",
		brand: "Risky Collection",
		url: "https://admin.monsinidress.com/uploads/Risky/2027/FA27/main/RS208/RS208.jpg",
		filename: "Risky RS208",
	},
];

/* =========================================================
   NEW ARRIVAL SECTION
========================================================= */

function NewArrivalSection({ latestYear = 2026 }) {
	const navigate = useNavigate();

	/* =======================================================
     NAVIGATION
  ======================================================= */

	const goToCollection = useCallback(() => {
		navigate(`/gowns/${latestYear}`);
	}, [latestYear, navigate]);

	/* =======================================================
     RENDER
  ======================================================= */

	return (
		<section
			className="
        flex
        w-full
        flex-col-reverse
        pt-[170px]

        md:h-auto
        md:flex-row
      "
			aria-labelledby="new-arrival-title">
			{/* =================================================
          IMAGE GRID
      ================================================== */}

			<div
				className="
          grid
          w-full
          grid-cols-1
          gap-2

          md:w-[85%]
          md:grid-cols-2

          lg:grid-cols-3
        ">
				{NEW_ARRIVAL_IMAGES.map((image, index) => (
					<button
						type="button"
						key={image.id || index}
						onClick={goToCollection}
						className="
                group
                block
                w-full
                cursor-pointer
                overflow-hidden
                text-left

                focus-visible:outline-none
                focus-visible:ring-4
                focus-visible:ring-[#8a459f]
              "
						aria-label={`View ${latestYear} ${image.brand} collection`}>
						<img
							src={image.url}
							alt={image.filename}
							loading={index === 0 ? "eager" : "lazy"}
							fetchPriority={index === 0 ? "high" : "auto"}
							className="
                  h-[600px]
                  w-full

                  bg-gray-100

                  object-cover
                  object-top

                  transition-transform
                  duration-500
                  ease-out

                  group-hover:scale-[1.02]

                  sm:h-[700px]

                  md:h-[800px]
                "
						/>
					</button>
				))}
			</div>

			{/* =================================================
          NEW ARRIVAL TITLE
      ================================================== */}

			<div
				className="
          flex
          h-auto
          w-full
          items-center
          justify-start

          bg-white

          py-5

          text-start

          md:h-[800px]
          md:w-[15%]
          md:justify-center
          md:py-0
        ">
				{/* MOBILE TITLE */}

				<h1
					id="new-arrival-title"
					className="
            block

            text-[50px]

            font-lora
            font-extrabold

            leading-[45px]

            tracking-wide

            text-[#713580]

            md:hidden
          ">
					NEW
					<br />
					ARRIVAL
				</h1>

				{/* DESKTOP TITLE */}

				<span
					className="
            hidden

            whitespace-nowrap

            font-lora
            font-extrabold

            tracking-widest

            text-[#713580]

            md:block

            md:rotate-[-270deg]

            md:text-[70px]
            md:leading-[80px]

            lg:text-[80px]
          "
					aria-hidden="true">
					NEW ARRIVAL
				</span>
			</div>
		</section>
	);
}

export default memo(NewArrivalSection);
